<template>
    <div class="admin">
        
    </div>
</template>
<script>

export default {
    name : "admin",
}
</script>


// WEBPACK FOOTER //
// src/components/main/index.vue